<!--  -->
<template>
  <div class="dialog-content">
    <div style="width: 50%">
      <div>
        <el-input v-model="query.sub_uc_id" style="width:250px;margin-right: 10px" placeholder="请输入子账号id" />
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
        <el-button type="primary" @click="clearAll">清空选项</el-button>
      </div>
      <el-table
        style="margin-top: 10px;"
        :data="account_list"
        border
      >
        <el-table-column
          fixed
          label="子账号id"
          width="120px"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="selectedRows"
              :label="scope.row.sub_uc_id"
              @change="handleCheckChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="120px" label="子账号名称" prop="sub_uc_name" />
        <el-table-column width="80px" label="子账户状态" prop="userStat" />
        <el-table-column width="130px" label="数量">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.num"
              :class="{ 'hidden-input': !selectedRows.includes(scope.row.sub_uc_id) }"
              placeholder="请输入数量"
              type="number"
              @input="handleQuantityChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="130px" label="落地页">
          <template slot-scope="scope">
            <el-autocomplete
              v-model="scope.row.onlineUrlName"
              :fetch-suggestions="querySearchAsync(scope.row)"
              :class="{ 'hidden-input': !selectedRows.includes(scope.row.sub_uc_id) }"
              placeholder="请输入落地页"
              popper-class="input_popper"
              @select="handleSelect(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="100px" label="备注">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              :class="{ 'hidden-input': !selectedRows.includes(scope.row.sub_uc_id) }"
              placeholder="请输入备注"
              @input="handleRemarkChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="180px" label="开始时间">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.begin_time"
              :class="{ 'hidden-input': !selectedRows.includes(scope.row.sub_uc_id) }"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
              :picker-options="pickerOptions"
              @change="handleStartDateChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="180px" label="结束时间">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.end_time"
              value-format="yyyy-MM-dd"
              :class="{ 'hidden-input': !selectedRows.includes(scope.row.sub_uc_id) }"
              type="date"
              :disabled="!scope.row.begin_time"
              placeholder="选择结束日期"
              :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"
              :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :current-page="query.page"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <div style="width: 50%">
      已选:
      <el-table
        :data="commit_list"
        style="margin-top: 10px"
        border
        height="500px"
      >
        <el-table-column
          prop="sub_uc_name"
          label="目标广告子账户名称"
        />
        <el-table-column
          prop="sub_uc_id"
          label="目标广告子账户"
        />
        <el-table-column
          prop="num"
          label="复制数量"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.num" type="number" placeholder="请输入数字" />
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column
          label="落地页(落地页id)"
        >
          <template slot-scope="scope">
            {{ scope.row.onlineUrlName }}({{ scope.row.onlineUrlId }})
          </template>
        </el-table-column>
        <el-table-column
          prop="begin_time"
          label="推广开始日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.begin_time"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="推广结束日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.end_time"
              type="date"
              :disabled="!scope.row.begin_time"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"
              :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"
            />
          </template>
        </el-table-column>
      </el-table>
      <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>
      <el-table
        :data="all_list"
        style="margin-top: 10px"
        border
      >
        <el-table-column
          prop="num"
          label="复制数量"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.num" type="number" placeholder="请输入数字" @input="AllTableChange(scope.row.num, 1)" />
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" placeholder="请输入备注" @input="AllTableChange(scope.row.remark, 2)" />
          </template>
        </el-table-column>
        <el-table-column label="开始时间">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.begin_time"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="AllTableChange(scope.row.begin_time, 3)"
            />
          </template>
        </el-table-column>
        <el-table-column label="结束时间">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.end_time"
              type="date"
              :disabled="!scope.row.begin_time"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              :disabled-date="(date) => disabledEndDate(date, scope.row.begin_time)"
              :picker-options="{ disabledDate: (date) => disabledEndDate(date, scope.row.begin_time) }"
              @change="AllTableChange(scope.row.end_time, 4)"
            />
          </template>
        </el-table-column>
      </el-table>
      <div style="float: right; margin: 20px">
        <el-button type="info" @click="$emit('close')">取消</el-button>
        <el-button type="success" @click="jobCreated">提交复制</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getBaiduADAccountList, jmyPageList } from '@/api/baiduAD'
import Vue from 'vue'

export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      account_list: [],
      total: null,
      query: {
        page: 1,
        pageSize: 10,
        sub_uc_id: null
      },
      commit_list: [],
      selectedRows: [],
      quantity: null,
      endDate: null,
      startDate: null,
      configInfo: false,
      all_list: [{
        num: null,
        begin_time: null,
        end_time: null,
        remark: null,
        onlineUrl: null
      }],
      urlData: null
    }
  },
  computed: {
    pickerOptions() {
      return {
        // 禁用今天之前的日期
        disabledDate: (time) => {
          const today = new Date()
          return time.getTime() < today.setHours(0, 0, 0, 0) // 今天之前的日期不可选
        }
      }
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    list() {
      getBaiduADAccountList(this.query).then(res => {
        this.account_list = res.data.list
        this.total = res.data.total
      })
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 处理复选框变化
    handleCheckChange(row) {
      if (this.commit_list.includes(row)) {
        // eslint-disable-next-line eqeqeq
        this.commit_list = this.commit_list.filter(item => item.sub_uc_id != row.sub_uc_id)
      } else {
        Vue.set(row, 'num', 1)
        Vue.set(row, 'begin_time', new Date())
        Vue.set(row, 'end_time', new Date())
        this.commit_list.push(row)
      }
    },
    handleQuantityChange(row) {
    },
    //
    handleRemarkChange(row) {
      //
    },
    handleStartDateChange(row) {
      //
    },
    disabledEndDate(date, startDate) {
      if (!startDate) {
        return false
      }
      const startDateTime = new Date(startDate).getTime()
      const minEndDateTime = startDateTime - 86400000
      return date.getTime() <= minEndDateTime
    },
    jobCreated() {
      var filter = this.commit_list.filter(res => !res.onlineUrl)
      if (filter.length !== 0) {
        this.$message.error('提交的数据当中落地页不能为空,请填写')
        return
      }
      this.$emit('jobCreated', this.commit_list)
    },
    AllTableChange(val, type) {
      // 根据 type 进行不同的处理
      switch (type) {
        case 1:
          this.commit_list.forEach(item => {
            Vue.set(item, 'num', val)
          })
          break
        case 2:
          this.commit_list.forEach(item => {
            Vue.set(item, 'remark', val)
          })
          break
        case 3:
          this.commit_list.forEach(item => {
            Vue.set(item, 'begin_time', val)
          })
          break
        case 4:
          this.commit_list.forEach(item => {
            Vue.set(item, 'end_time', val)
          })
          break
        default:
          console.warn(`没有输入类型`)
      }
    },
    querySearchAsync(row) {
      return (queryString, cb) => {
        this.fetchSuggestions(queryString, row.sub_uc_id, cb)
      }
    },
    fetchSuggestions(queryString, sub_uc_id, cb) {
      // 模拟异步请求
      jmyPageList({
        sub_uc_id: sub_uc_id,
        search_key: queryString
      }).then(res => {
        this.urlData = res.data
        const results = this.urlData.map(item => ({
          value: item.pageName
        }))
        cb(results)
      })
    },
    handleSelect(row) {
      const urlNName = this.urlData.find(item => {
        if (item.pageName === row.onlineUrlName) {
          return item.onlineUrl
        }
      })
      this.$set(row, 'onlineUrl', urlNName.onlineUrl)
      this.$set(row, 'onlineUrlId', urlNName.pageId)
    },
    clearAll() {
      this.commit_list = []
      this.selectedRows = []
    },
    search() {
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.pageSize = 10
      this.query.sub_uc_id = null
      this.clearAll()
      this.list()
    }
  }
}
</script>
<style scoped>
.dialog-content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  height: 90%;
}
.hidden-input {
  visibility: hidden;
}
.input_popper {
  width: 300px;
  max-height: 500px;
}
</style>
